import { gsap } from 'gsap';

export default () => {
	const button = document.querySelector('.js-open-cart');
	const buttonClose = document.querySelector('.js-close-cart');
	const cart = document.querySelector('.cart');
	const CLASS_VISIBLE = 'cart--visible';

	if (button && cart) {
		button.addEventListener('click', (e) => {
			e.preventDefault();
			cart.classList.toggle(CLASS_VISIBLE);
		});

		cart.addEventListener('click', (e) => {
			if(!e.target.closest('.cart__body')) {
				cart.classList.remove(CLASS_VISIBLE);
			}
		});

		if (buttonClose) {
			buttonClose.addEventListener('click', (e) => {
				e.preventDefault();
				
				cart.classList.remove(CLASS_VISIBLE);
			});
		}

		if (window.location.href.includes('#cart')) {
			removeHash();
			openCart();
		}
	}

	function closeCart() {
		if (cart) {
			cart.classList.remove(CLASS_VISIBLE);
		}
	}
	function openCart() {
		if (cart) {
			cart.classList.add(CLASS_VISIBLE);
		}
	}
	

	document.addEventListener('click', (e) => {
		if (e.target.closest('.js-buy-btn')) {
			const btn = e.target;
			let id = +btn.dataset.id;
			let quantity = 1;

			if (id && quantity) {
				const items = [];
				const item = {
					id: id,
					quantity: quantity
				}
				items.push(item);
				addToCart(items);
			}
		}

		if (e.target.closest('.js-buy-set')) {
			const items = [];
			const activeSwatches = document.querySelectorAll('.selector__radio--active');
			activeSwatches.forEach(function(swatch) {
				const id = +swatch.dataset.id;

				const item = {
					id: id,
					quantity: 1
				}
				items.push(item);
			});

			if (items.length > 0) {
				addToCart(items);
			}
		}
	});
	
	
	document.addEventListener('click', (e) => {
		if (e.target.closest('.js-line-remove')) {
			let item = e.target.closest('.js-cart-item')
			let line = +item.dataset.index;

			removeFromCart(line);
		}

		if (e.target.closest('.js-line-remove')) {
			let item = e.target.closest('.js-cart-item')
			let line = +item.dataset.index;

			removeFromCart(line);
		}

		if (e.target.closest('.js-quantity-minus')) {
			let item = e.target.closest('.js-cart-item')
			let line = +item.dataset.index;
			let count = +item.querySelector('.quantity__input').value;

			changeCart(line, count-1);
		}
		if (e.target.closest('.js-quantity-plus')) {
			let item = e.target.closest('.js-cart-item')
			let line = +item.dataset.index;
			let count = +item.querySelector('.quantity__input').value;

			changeCart(line, count+1);
		}
		if (e.target.closest('.cart__discount-expand')) {
			e.target.style.display = 'none';
			const form = e.target.nextElementSibling;

			if (form) {
				gsap.to(form, {
					'height' :'auto'
				})
			}
		}
	});


	async function addToCart(items_arr) {
		let basketPopup = document.querySelector('.basket-popup')
		
		let data = {
			items: items_arr
		};
		
		let response = await fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json;charset=utf-8'
			},
			body: JSON.stringify(data)
		});
		

		if (response.status === 200) {
			renderCart();
			loading(false);
			openCart();
		} else if (response.status === 422) {
			console.log('out of stock');
			
		} else {
			console.log('product add error');
			loading(false);
		}
	}

	async function removeFromCart(line) {
		loading(true);

		let data = {
			'line': line,
			'quantity': 0
		};
		
		let response = await fetch('/cart/change.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json;charset=utf-8'
			},
			body: JSON.stringify(data)
		});
		if (response.status === 200) {
			renderCart();
			loading(false);
			openCart();
		}
	}

	async function changeCart(line, q) {
		loading(true);
		let data = {
			'line': line,
			'quantity': q
		};

		let response = await fetch('/cart/change.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json;charset=utf-8'
			},
			body: JSON.stringify(data)
		});

		if (response.status === 200) {
			renderCart();
			loading(false);
		} else if (response.status === 422) {
			console.log('out of stock');
			loading(false);
		} else {
			console.log('product add error');
			loading(false);
		}
	}



	function loading(isLoading) {
		const wrappers = document.querySelectorAll('.js-cart-wrapper');
		const LOADING_CLASS = 'loading';

		wrappers.forEach(function(wrapper) {
			if (isLoading) {
				wrapper.classList.add(LOADING_CLASS);
			} else {
				wrapper.classList.remove(LOADING_CLASS);
			}
		});
	}

	function barProgress() {
		let delivery = document.querySelector('.delivery');
		

		if (delivery) {
			let progressEl = delivery.querySelector('.delivery__bar-progress');
			let rate = +Shopify.currency.rate;
			let current = +delivery.dataset.current;
			let target = +delivery.dataset.target*rate;
			let marginAmount = delivery.querySelector('.delivery__text span');
			let textItems = delivery.querySelectorAll('.delivery__text');

			let progress = Math.min(100*current/target, 100);
			progressEl.style.width = `${progress}%`;

			if (marginAmount && progress<100) {
				marginAmount.innerText = `${window.symbol}${Math.floor(target - current)}`;
			}

			if (progress<100) {
				textItems[0].style.display = 'block';
			} else {
				textItems[1].style.display = 'block';
			}
		}
	}


	function renderCart() {
		const base = window.location.href.split('?')[0];
		const cartUrl = '/cart?view=alt'
		const url = `${base}${cartUrl}`;

		fetch(url).then(function (response) {
			return response.text();
		}).then(function (html) {

			const element = document.createElement('div');
			element.innerHTML = html;
			const newCart = element.querySelector('.js-cart-insert');

			const cartWrapper = document.querySelector('.js-cart-insert');
			cartWrapper.innerHTML = newCart.innerHTML;

			barProgress();
			discount();

		}).catch(function (err) {
			console.warn('Something went wrong.', err);
		});
	}

	function discount() {
		const btn = document.querySelector('.js-discount-button');
		const input = document.querySelector('.js-discount-input');

		if (btn && input) {
			input.addEventListener('input', (e) => {
				if (input.value) {
					btn.classList.remove('disabled');
					btn.href = Shopify.routes.root+btn.dataset.href+input.value;
				} else {
					btn.classList.add('disabled');
					btn.href = '#';
				}
			});
		}
	}
	function removeHash() {
		history.pushState("", document.title, window.location.pathname + window.location.search);
	}

	barProgress();
	discount();
};